import car01 from "../images/car-01.png";
import car02 from "../images/car-02.png";
import car03 from "../images/car-03.png";
import car04 from "../images/car-04.png";
import car05 from "../images/car-05.png";
import car06 from "../images/car-06.png";

const bookingCars = [
  {
    id: "01",
    carName: "Porshe 718 Cayman S",
    category: "Audi",
    type: "Manual",
    groupSize: 4,
    rentPrice: 89,
    imgUrl: car01,
  },
  {
    id: "02",
    carName: "Porshe 718 Cayman S",
    category: "Toyota",
    type: "Manual",
    groupSize: 4,
    rentPrice: 59,
    imgUrl: car02,
  },
  {
    id: "03",
    carName: "Porshe 718 Cayman S",
    category: "Bmw",
    type: "Manual",
    groupSize: 4,
    rentPrice: 109,
    imgUrl: car03,
  },
  {
    id: "04",
    carName: "Porshe 718 Cayman S",
    category: "Coupe",
    type: "Manual",
    groupSize: 4,
    rentPrice: 99,
    imgUrl: car04,
  },
  {
    id: "05",
    carName: "Porshe 718 Cayman S",
    category: "Bmw",
    type: "Manual",
    groupSize: 4,
    rentPrice: 109,
    imgUrl: car05,
  },
  {
    id: "06",
    carName: "Porshe 718 Cayman S",
    category: "Toyota",
    type: "Manual",
    groupSize: 4,
    rentPrice: 89,
    imgUrl: car06,
  },
  {
    id: "07",
    carName: "Porshe 718 Cayman S",
    category: "Audi",
    type: "Manual",
    groupSize: 4,
    rentPrice: 89,
    imgUrl: car01,
  },
  {
    id: "08",
    carName: "Porshe 718 Cayman S",
    category: "Toyota",
    type: "Manual",
    groupSize: 4,
    rentPrice: 59,
    imgUrl: car02,
  },
  {
    id: "09",
    carName: "Porshe 718 Cayman S",
    category: "Bmw",
    type: "Manual",
    groupSize: 4,
    rentPrice: 109,
    imgUrl: car03,
  },
];

export default bookingCars;
